import React, {FC} from "react";
import {
    FacebookIcon,
    FacebookShareButton,
    PinterestIcon,
    PinterestShareButton,
    TwitterIcon,
    TwitterShareButton,
} from "next-share";
import {domainUrl} from "../../helper";
import {useGlobal} from "../../hooks/useGlobal";
import {useSelector} from "react-redux";
import {IState} from "../../types/state";

interface IProps {
    url: any
}

const SMSharedButton: FC<IProps> = ({url}) => {
    const {dbName, domain} = useGlobal()
    const cacheVersion = useSelector((state: IState) => state.general.cashVersion)
    const logoPath = domainUrl(`${dbName}/storage/${domain}/configuration/logo/logo.webp?v=${cacheVersion}`)
    return (
        <>
            <FacebookShareButton url={url}>
                <FacebookIcon size={32} round/>
            </FacebookShareButton>
            <TwitterShareButton url={url}>
                <TwitterIcon size={32} round/>
            </TwitterShareButton>
            <PinterestShareButton url={url} media={logoPath}>
                <PinterestIcon size={32} round/>
            </PinterestShareButton>
        </>
    );
}

export default SMSharedButton